'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var moment = require('moment');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);

function formatPhoneNumber(phoneNumber) {
  var regexObj = /^(?:\+?1[-. ]?)?(?:\(?([0-9]{3})\)?[-. ]?)?([0-9]{3})[-. ]?([0-9]{4})$/;

  if (regexObj.test(phoneNumber)) {
    var parts = phoneNumber.match(regexObj);
    var phone = "";
    if (parts[1]) phone += "(".concat(parts[1], ") ");
    phone += "".concat(parts[2], "-").concat(parts[3]);
    return phone;
  } else {
    return phoneNumber;
  }
}
function formatDate(date) {
  if (!date) return "";
  var momentDate = moment__default["default"](date);

  if (momentDate.isValid()) {
    return momentDate.format('MM/DD/YYYY');
  } else {
    return "Invalid date";
  }
}
function formatDayAndTime(date) {
  if (!date) return '';
  var momentDate = moment__default["default"](date);

  if (momentDate.isValid()) {
    return momentDate.format('ddd h:mmA');
  }

  return '';
}
function buildAddressLineOne(address) {
  if (!address) return null;
  var street = address.street,
      street_line_2 = address.street_line_2;
  var line1 = '';

  if (street) {
    line1 = street_line_2 ? "".concat(street, ", ") : "".concat(street);
  }

  if (street_line_2) line1 += "".concat(street_line_2, " ");
  return line1;
}
function buildAddressLineTwo(address) {
  if (!address) return null;
  var city = address.city,
      state = address.state,
      zip = address.zip;
  var line2 = '';

  if (city) {
    line2 = state || zip ? "".concat(city, ", ") : "".concat(city);
  }

  if (state) line2 += "".concat(state, " ");
  if (zip) line2 += "".concat(zip);
  return line2;
}

exports.buildAddressLineOne = buildAddressLineOne;
exports.buildAddressLineTwo = buildAddressLineTwo;
exports.formatDate = formatDate;
exports.formatDayAndTime = formatDayAndTime;
exports.formatPhoneNumber = formatPhoneNumber;
